import { render, staticRenderFns } from "./ChallengeRelatedChallenges.vue?vue&type=template&id=b5e35d3c"
import script from "./ChallengeRelatedChallenges.vue?vue&type=script&lang=ts"
export * from "./ChallengeRelatedChallenges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports